import React from 'react'
import './LoadingSpinner.css'

interface LoadingSpinnerProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
  className?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Loading...', 
  size = 'medium',
  className = '' 
}) => {
  return (
    <div className={`loading-screen ${className}`} role="status" aria-live="polite">
      <div className={`spinner spinner-${size}`} aria-hidden="true"></div>
      <p className="sr-only">{message}</p>
      <p aria-hidden="true">{message}</p>
    </div>
  )
}

export default LoadingSpinner
